import { Component, OnInit, Input } from '@angular/core';
import { ProformaStateFront } from '../../../models/api.models';

@Component({
  selector: 'app-proforma-state-chip',
  templateUrl: './proforma-state-chip.component.html',
  styleUrls: ['./proforma-state-chip.component.scss'],
})
export class ProformaStateChipComponent implements OnInit {

  @Input() proformaStateFront: ProformaStateFront = new ProformaStateFront();

  constructor() { }

  ngOnInit() {}

}
